export const internalAccountsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'accountId',
    label: 'Account No.',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'currencyId',
    label: 'Balance',
  },
];

export const internalAccountsDefaultSorter = {};

export const internalAccountsSchema = {};
